import React, { Component } from 'react'
import { Col, Label, Row } from 'reactstrap'
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { observer } from 'mobx-react'
import ModalForm from '../../../comum/components/ModalForm'
import LoadingImage from '../../../comum/components/LoadingImage';
import { formatarDataCustomHTML, formatNullableValue } from '../../../../utils/formatar';

@observer
export default class ModalDetalhesMobile extends Component {

    constructor(props) {

        super(props)

        this.controller = this.props.controller
    }

    renderFields(col, detalhe) {
        if(col.formatter) {
            return (
                <div className="info bg-cinza">
                    <div className="titulo">{col.text}</div>
                    <div className="valor">
                        {formatNullableValue( col.formatter(detalhe[col.dataField], this.props.data))}
                    </div>
                </div>
            );
        } else {
            return (
                <div className="info bg-cinza">
                    <div className="titulo">{col.text}</div>
                    <div className="valor">
                        {formatNullableValue(detalhe[col.dataField], this.props.data)}
                    </div>
                </div>
            );
        }
    }

    render() {
        
        return (
            <ModalForm
                className="modal-detalhes-orcamento"
                esconderSalvar={true}
                labelCancelar="FECHAR"
                onClickCancelar={() => this.controller.toggleModal(null, null, "detalhes", false)}
            >
                {
                    this.controller.loadingDetalhe
                    ?<Row><Col><LoadingImage /></Col></Row>
                    :<React.Fragment>
                        <Row className="px-0">
                            <Col className="cabecalho">
                                <h2>Detalhes do orçamento</h2>
                                <Label className="situacao-btn px-2 tag">{this.controller.formatTipo(this.controller.row.TipoOrcamento)}</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={4} sm={4} md={4}>
                                <div className="informacoes">
                                    <Label>
                                        Acesso
                                    </Label>
                                    <div>
                                        {formatarDataCustomHTML(this.controller.row.DtOrcamento)}
                                    </div>
                                </div>
                            </Col>
                            <Col xs={4} sm={4} md={4}>
                                <div className="informacoes">
                                    <Label>
                                        Usuário
                                    </Label>
                                    <div>
                                        {this.controller.row.UsuarioOrcamento}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <div>
                            {/* <ToolkitProvider
                                keyField="OsId"
                                data={[...this.controller.listaDetalhe]}
                                columns={[...this.controller.colunasDetalhes]}
                            >
                                {
                                    props => <div className="tabela-detalhes">
                                        <div className="tabela-detalhes__conteudo">
                                            <BootstrapTable boostrap4
                                                stripped
                                                bordered={false}
                                                classes="tabela tabela-layout cabotagem"
                                                {...props.baseProps}
                                            />
                                        </div>
                                    </div>
                                }
                            </ToolkitProvider> */}
                            <div style={{maxHeight: '30vh'}}>
                                <div style={{maxHeight: '29vh', overflow:'auto'}}>
                                    {
                                        this.controller.listaDetalhe.map((detalhe) => {
                                            return (<div className="card-navio" key={detalhe.OsId}>
                                                <Row xs={12} className="px-0">
                                                    <Col xs={12} className="px-0">
                                                        <div className="titulo">
                                                            <Label className="titulo-principal">{ detalhe.OsId }</Label>
                                                        </div>
                                                    </Col>
                                                    {
                                                        this.controller.colunasDetalhes.map((col, index) => 
                                                        (col.dataField !== "OsId") &&
                                                        <Col xs={6} className="px-0" key={index}>
                                                            {this.renderFields(col, detalhe)}
                                                        </Col>
                                                        )
                                                    }
                                                </Row>
                                            </div>)
                                        })
                                    }
                                </div>
                            </div>
                        <Row className="info-rodape mx-0 pt-2">
                            <Col>
                                <div className="label">
                                    Nº Documento
                                </div>
                                <div>
                                    {this.controller.detalhesData.Documento}
                                </div>
                            </Col>
                            <Col>
                                <div className="float-right">
                                    <div className="label">
                                        Total a pagar
                                    </div>
                                    <div>
                                        {this.controller.detalhesData.TotalPagar && this.controller.detalhesData.TotalPagar.toLocaleString('pt-BR',{style:'currency', currency:'BRL', minimumFractionDigits:2})}
                                    </div>

                                </div>
                            </Col>
                        </Row>
                        </div>
                        <div className="rodape-detalhes my-4">
                            <span className="rodape-detalhes__valor">{this.controller.listaDetalhe.length}</span> Serviços
                        </div>
                    </React.Fragment>
                }
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/consulta/components/ModalDetalhesMobile.js